export const tripShareEn = {
  shareTrip: 'Share trip',
  peopleWithAccess: 'People with access',
  invite: 'Invite',
  sendInvite: 'Send invite',
  role: 'Role',
  editor: 'Editor',
  viewer: 'Viewer',
  pending: 'Pending',
  active: 'Active',
  revoked: 'Revoked',
  members: 'Members',
  emptyRoster: 'No members yet. Invite a connection to share this trip.',
  changeRole: 'Change role',
  remove: 'Remove',
  inboxTitle: 'Trip invitations',
  inboxEmpty: 'When someone shares a trip with you, it will appear here.',
  pendingSection: 'Pending',
  sharedWithMe: 'Shared with me',
  accept: 'Accept',
  decline: 'Decline',
  leave: 'Leave trip',
  from: 'From',
  unnamedTrip: 'Shared trip',
  memberCap: 'This trip already has the maximum number of members (20).',
  memberCapHint: 'Up to 20 people can share this trip.',
  invitationUnavailable: 'This invitation is no longer available',
  readOnlyBanner: 'View only — you can browse this trip but not edit it.',
  attachmentOwnerOnly: 'Only the trip owner can open attachments',
  sharedBadge: 'Shared',
  loading: 'Loading…',
  retry: 'Retry',
  accepted: 'Trip invitation accepted',
  inviteSent: 'Invitation sent',
  inviteSentOne: 'Invitation sent',
  inviteSentMany: (n: number) => `${n} invitations sent`,
  left: 'You left the shared trip',
  openInbox: 'Trip invitations',
  printItinerary: 'Print itinerary',
  activeMembers: 'Active members',
  sentInvites: 'Invites you have sent',
  sentInvitesEmpty: 'No pending invites',
  resendInvite: 'Resend invite',
  backToRoster: 'Back',
  channelPicker: 'Invite channel',
  channelQr: 'QR',
  channelConnection: 'Connection',
  channelEmail: 'Email',
  channelSms: 'SMS',
  channelsHint:
    'Share a QR code, invite a connection, or send an email or SMS invite.',
  refreshQr: 'Refresh QR',
  qrEndDateRequired: 'Trip end date is required for trip-scoped QR codes.',
  qrGenerateFailed: 'Could not generate QR code. Try again.',
  selectConnections: 'Select connections',
  searchConnections: 'Search connections',
  noConnections: 'No connections to share with yet.',
  enableCommunityTitle: 'Enable Community Features?',
  enableCommunityMessage:
    'Community Features must be on to share trips. You can turn this off later in Settings.',
  enableCommunityConfirm: 'Enable',
  cancel: 'Cancel',
  connectionInviteHeading: 'Invite by email or SMS',
  connectionInviteEmail: 'Email',
  connectionInvitePhone: 'Phone',
  connectionInviteEmailPlaceholder: 'friend@example.com',
  connectionInvitePhonePlaceholder: '+1 555 123 4567',
  connectionInviteMessage: 'Optional message',
  connectionInviteSendEmail: 'Send email invite',
  connectionInviteSendSms: 'Send SMS invite',
  connectionInviteSent: 'Connection invite sent',
  connectionInviteCopyLink: 'Copy invite link',
  connectionInviteLinkCopied: 'Invite link copied',
  connectionInviteFailed: 'Could not send invite. Try again.',
  connectionInviteInvalidEmail: 'Enter a valid email address.',
  connectionInviteInvalidPhone: 'Enter a valid phone number.',
} as const;
